import { useLocation, useNavigate } from "react-router-dom";
import { Home, MapPin, User } from "lucide-react";
import { useAuth } from "@/App";
import { t } from "@/i18n";

export const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const navItems = [
    { path: "/", icon: Home, label: t('nav.home') },
    { path: "/locations", icon: MapPin, label: t('nav.locations') },
    { path: user ? "/profile" : "/auth", icon: User, label: user ? t('nav.profile') : t('nav.login') },
  ];

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    if (path === "/profile") return location.pathname === "/profile" || location.pathname === "/auth";
    if (path === "/auth") return location.pathname === "/auth" || location.pathname === "/profile";
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 glass-nav border-t border-gray-100 z-50">
      <div className="max-w-lg mx-auto px-6">
        <div className="flex items-center justify-around h-16">
          {navItems.map((item) => {
            const active = isActive(item.path);
            const Icon = item.icon;
            return (
              <button
                key={item.path}
                data-testid={`nav-${item.label.toLowerCase()}`}
                onClick={() => navigate(item.path)}
                className={`nav-item relative flex flex-col items-center gap-1 px-4 py-2 transition-colors ${
                  active ? "active text-[#1a4d2e]" : "text-[#6b7280] hover:text-[#111827]"
                }`}
              >
                <Icon className="w-5 h-5" strokeWidth={active ? 2.5 : 2} />
                <span className="text-xs font-medium">{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};
